<div class="chip">
  <span class="chip__label">{{label}}</span>
  <span
    class="pi pi-times-circle pi-chip-remove-icon chip__icon"
    (click)="remove()"
  ></span>
</div>
